import config from '@config';

// to have the proper types on the client this can't have a type, if debugging
// is needed ClientSpec can be used as the type
const V2APISpec = {
  base: config.api.v2,
  logs: false,

  headers: {
    'x-litlingo-auth-no-redirect': 'true',
    'block-overwrite': 'true',
    'cache-control': 'no-cache',
  },

  resources: {
    users: {
      path: '/users',
      include: [],
      extras: {
        me: {
          path: '/me',
          method: 'GET',
        },
        customers: {
          path: '/me/customers',
          method: 'GET',
        },
        metricCustomers: {
          path: '/metric/customers',
          method: 'GET',
        },
        socketToken: {
          path: '/socket-token',
          method: 'POST',
        },
      },
    },
    categories: {
      path: '/categories',
      include: ['UPSERT', 'LIST', 'RETRIEVE', 'DELETE'],
      extras: {
        bulkPut: {
          path: '/bulk-put',
          method: 'POST',
        },
      },
    },
    identifiers: {
      path: '/identifiers',
      include: ['UPSERT', 'LIST', 'RETRIEVE', 'DELETE'],
      extras: {
        getRevisions: {
          path: '/revisions',
          method: 'GET',
        },
        getIdentifierRevisions: {
          path: '/{identifierId}/revisions',
          method: 'GET',
        },
        getRevision: {
          path: '/revisions/{revisionsId}',
          method: 'GET',
        },
        getCustomers: {
          path: '/revisions/{revisionsId}/customers',
          method: 'GET',
        },
        getCategories: {
          path: '/revisions/{revisionsId}/categories',
          method: 'GET',
        },
        upsertIdentifierRevision: {
          path: '/{identifierId}',
          method: 'PUT',
        },
        bulkDelete: {
          path: '/bulk/delete',
          method: 'POST',
        },
        cloneIdentifier: {
          path: '/{identifierId}/clone',
          method: 'POST',
        },
        merge: {
          path: '/merge',
          method: 'POST',
        },
        heads: {
          path: '/heads',
          method: 'GET',
        },
        promoteIdentifier: {
          path: '/{identifierId}/heads/{headId}/promote',
          method: 'POST',
        },
        getRenderedPrompts: {
          path: '/render-prompts',
          method: 'POST',
        },
      },
    },
    models: {
      path: '/models',
      include: ['UPSERT', 'LIST', 'RETRIEVE', 'DELETE'],
      extras: {
        getCategories: {
          path: '/{modelId}/categories',
          method: 'GET',
        },
        bulkUpdateKind: {
          path: '/bulk_update_kind',
          method: 'POST',
        },
        cloneModel: {
          path: '/{modelId}/clone',
          method: 'POST',
        },
        acceptChanges: {
          path: '/{modelId}/accept',
          method: 'POST',
        },
      },
    },
    ruleGroups: {
      path: '/rules',
      include: ['UPSERT', 'LIST', 'RETRIEVE', 'DELETE'],
      extras: {
        getLatestRevision: {
          path: '/{ruleId}/head',
          method: 'GET',
        },
        getRevisions: {
          path: '/revisions',
          method: 'GET',
        },
        getRevision: {
          path: '/revisions/{revisionsId}',
          method: 'GET',
        },
        getCustomers: {
          path: '/revisions/{revisionsId}/customers',
          method: 'GET',
        },
        getRuleRevisions: {
          path: '/{ruleId}/revisions',
          method: 'GET',
        },
        upsertRuleRevision: {
          path: '/{ruleId}',
          method: 'PUT',
        },
        preview: {
          path: '/revisions/{revisionId}/preview',
          method: 'POST',
        },
        previewGroup: {
          path: '/{ruleGroupId}/preview',
          method: 'POST',
        },
        changelog: {
          path: '/{revisionId}/audit-logs',
          method: 'GET',
        },
        cloneRule: {
          path: '/{ruleId}/clone',
          method: 'POST',
        },
        diffRevisions: {
          path: '/{revisionIdOne}/diff/{revisionIdTwo}',
          method: 'POST',
        },
        promoteRule: {
          path: '/{groupId}/heads/{headId}/promote',
          method: 'POST',
        },
        llmPrompts: {
          path: '/{groupId}/llm-prompts',
          method: 'GET',
        },
      },
    },
    communications: {
      path: '/communications',
      include: [],
      extras: {
        preview: {
          path: '/preview',
          method: 'POST',
        },
        document: {
          path: '{communicationId}/document',
          method: 'GET',
        },
        previewFeedback: {
          path: '/preview-feedback',
          method: 'POST',
        },
      },
    },
    ModelMetrics: {
      path: '/model_metrics',
      include: ['UPSERT', 'LIST', 'RETRIEVE', 'DELETE'],
      extras: {},
    },
    identifiers_in_communications: {
      path: '/identifiers_in_communications',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        counts: {
          path: '/',
          method: 'GET',
        },
      },
    },
    models_in_body: {
      path: '/models_in_body',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        counts: {
          path: '/',
          method: 'GET',
        },
      },
    },
    models_in_attachment: {
      path: '/models_in_attachment',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        counts: {
          path: '/',
          method: 'GET',
        },
      },
    },
    rules_in_body: {
      path: '/rules_in_body',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        counts: {
          path: '/',
          method: 'GET',
        },
      },
    },
    rules_in_attachment: {
      path: '/rules_in_attachment',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        counts: {
          path: '/',
          method: 'GET',
        },
      },
    },
    termsList: {
      path: '/terms_list',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        getTerms: {
          path: '/{termsListId}/terms',
          method: 'GET',
        },
        addTerms: {
          path: '/{termsListId}/terms',
          method: 'POST',
        },
        deleteTerms: {
          path: '/{termsListId}/terms',
          method: 'DELETE',
        },
      },
    },
    investigations: {
      path: '/investigations',
      include: ['LIST', 'UPSERT', 'RETRIEVE', 'DELETE'],
      extras: {
        listEnvelopes: {
          path: '/{investigationId}/envelopes',
          method: 'GET',
        },
        addEnvelopeByEnvelope: {
          path: '/{investigationId}/envelopes/by-envelope',
          method: 'POST',
        },
        addEnvelopesBySearch: {
          path: '/{investigationId}/envelopes/by-search',
          method: 'POST',
        },
        addEnvelopesBySender: {
          path: '/{investigationId}/envelopes/by-sender',
          method: 'POST',
        },
        addEnvelopesByThread: {
          path: '/{investigationId}/envelopes/by-thread',
          method: 'POST',
        },
        deleteEnvelopeLink: {
          path: '/{investigationId}/envelopes/{linkUuid}',
          method: 'DELETE',
        },
        pushToEpiquDiscover: {
          path: '/{investigationId}/push',
          method: 'POST',
        },
        getAgentSessions: {
          path: '/{investigationId}/agent-sessions',
          method: 'GET',
        },
        startAgentSession: {
          path: '/{investigationId}/agent-sessions',
          method: 'POST',
        },
      },
    },
  },
} as const;

export default Object.freeze(V2APISpec);
